import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import Tours from "./components/Tours";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

import FreeWalkingTour from "./components/tours/FreeWalkingTour";
import BeratCastleTour from "./components/tours/BeratCastleTour";
import FoodWineTour from "./components/tours/FoodWineTour";

import { MapProvider } from "./components/MapLoader"; // Import MapProvider

function App() {
  return (
    <MapProvider apiKey="YOUR_REAL_GOOGLE_MAPS_API_KEY">
      <Router>
        <Navbar />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Home />
                <About />
                <Tours />
                <Contact />
                <Footer />
              </>
            }
          />

          {/* Tour pages */}
          <Route path="/tours/free-walking" element={<FreeWalkingTour />} />
          <Route path="/tours/berat-castle-private" element={<BeratCastleTour />} />
          <Route path="/tours/food-wine" element={<FoodWineTour />} />
        </Routes>
      </Router>
    </MapProvider>
  );
}

export default App;
